var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPolicyParamAttribute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.333L8.937 2.27c-.346-.346-.519-.519-.72-.642a2 2 0 00-.579-.24c-.23-.055-.474-.055-.963-.055H4M2 5.8v1.316c0 .326 0 .49.037.643.033.136.086.266.16.385.082.135.197.25.428.48l5.2 5.2c.528.528.792.793 1.096.892.268.087.557.087.824 0 .305-.1.569-.364 1.097-.891l1.65-1.65c.527-.528.791-.792.89-1.097a1.334 1.334 0 000-.824c-.098-.304-.362-.568-.89-1.096L7.625 4.29c-.23-.23-.346-.346-.48-.428a1.334 1.334 0 00-.386-.16c-.153-.037-.317-.037-.643-.037H4.133c-.746 0-1.12 0-1.405.146-.25.127-.455.331-.583.582C2 4.68 2 5.053 2 5.8z",
    stroke: "#0C6A64",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPolicyParamAttribute;